import {
    sentryClient,
    sentryKey,
    sentryProject,
    version,
    agentPath,
    env,
    allowCookies,
} from 'utils/settings';

const sentryInstance = window.ikea.sentry;

const sentryEnabled =
    sentryInstance &&
    sentryKey &&
    sentryProject &&
    sentryClient &&
    version &&
    allowCookies;

if (sentryEnabled) {
    const regex = new RegExp(agentPath, '');
    sentryInstance.register(
        sentryProject,
        sentryKey,
        sentryClient,
        version,
        1, // Log 100% of errors for now
        [regex]
    );
} else {
    console.warn('[favs-agent] Sentry is not active');
}

export const reportError = (e: Error | string) => {
    if (sentryEnabled) {
        sentryInstance.store(
            e,
            sentryProject,
            sentryKey,
            sentryClient,
            version,
            1
        );
    }
    if (env !== 'production') {
        console.error(e);
    }
};
